import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { adminApi } from "../../lib/adminApi";
import { toast } from "sonner";

export default function Emails() {
  const [emails, setEmails] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchEmails = async () => {
    setLoading(true);
    try {
      const data = await adminApi.getEmails({ page, limit: 20 });
      setEmails(data.data);
      setTotal(data.total);
    } catch (e) {
      toast.error(e.message);
    }
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchEmails(); }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this email?")) return;
    try {
      await adminApi.deleteEmail(id);
      toast.success("Email deleted");
      fetchEmails();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Emails ({total})</h1>

      {loading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Email</TableHead>
                <TableHead>Store ID</TableHead>
                <TableHead>Created</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {emails.map((email) => (
                <TableRow key={email.id}>
                  <TableCell>{email.email}</TableCell>
                  <TableCell className="font-mono text-sm">{email.store_id || "-"}</TableCell>
                  <TableCell>{new Date(email.created_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button variant="destructive" size="sm" onClick={() => handleDelete(email.id)}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <div className="flex justify-center gap-2 mt-4">
            <Button variant="outline" disabled={page === 1} onClick={() => setPage(page - 1)}>
              Previous
            </Button>
            <span className="py-2 px-4">Page {page}</span>
            <Button variant="outline" disabled={emails.length < 20} onClick={() => setPage(page + 1)}>
              Next
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
